import { useClient, fetchCurrentClient } from "~/composables/useAuth";

export default defineNuxtPlugin(async () => {
  const client = useClient();

  if (client.value === undefined || client.value === null) {
    const response = await fetchCurrentClient();
    if (response) {
      client.value = response.data;
    }
  }
});
